export const ru = {
    new_group_title: 'Новая группа пользователей',
    delete_group: 'Удалить группу',
    error_title: 'Что-то пошло не так',
    error_description: 'Попробуйте перезагрузить страницу или обратиться в поддержку, если ошибка повторяется',
    confirmation_delete_title: 'Подтверждение',
    confirmation_delete_message: 'Вы точно хотите удалить данную группу пользователей?',
};
